import React, {FC} from "react";
import './SecondaryMarketOffer.scoped.scss';
import {SellingOffer} from "../../../../../api-client";
import {ProjectFavorite} from "../../index";
import {BoldText, CustomLink, Money, PrimaryButton} from "../../../../common";
import {GridRowHeader} from "../../../../layout/grid";
import {PrimaryButtonColor} from "../../../../common/buttons/decorators/PrimaryButton/PrimaryButton";
import {RouteDictionary} from "../../../../../utils";

interface Props {
    offer: SellingOffer;
}

const SecondaryMarketOffer: FC<Props> = ({offer}) => {
  return (
    <li className="primary-market-offer">
      <div className="primary-market-offer__column primary-market-offer__primary">
        <div className="primary-market-offer__title">
          <ProjectFavorite>
            <div>
              {offer.project.paymentCode}
            </div>
          </ProjectFavorite>
          <BoldText>
            <div className="primary-market-offer__name">
              {offer.project.name[0].text}
            </div>
          </BoldText>
        </div>
      </div>
      <div className="primary-market-offer__column primary-market-offer__term">
        <GridRowHeader>
          Срок
        </GridRowHeader>
        <div>
          {offer.project.initialTerm} мес.
        </div>
      </div>
      <div className="primary-market-offer__column primary-market-offer__simple">
        <GridRowHeader>
          Доходность простая
        </GridRowHeader>
        <div>
          {offer.project.simpleInterestRate?.toFixed(2)}%
        </div>
      </div>
      <div className="primary-market-offer__column primary-market-offer__yearly">
        <GridRowHeader>
          Доходность годовая
        </GridRowHeader>
        <div>
          {offer.project.interestRate?.toFixed(2)}%
        </div>
      </div>

      <div className="primary-market-offer__column primary-market-offer__actions">
        <PrimaryButton expanded className="primary-market-offer__link" color={PrimaryButtonColor.GREEN}>
          <CustomLink to={RouteDictionary.PURCHASE_OFFER} params={{offerUuid: offer.uuid}}>
            Купить
          </CustomLink>
        </PrimaryButton>
      </div>
    </li>
  );
};

export default SecondaryMarketOffer;